import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-placements-otherinfo-list',
  templateUrl: './placements-otherinfo-list.component.html',
  styleUrls: ['./placements-otherinfo-list.component.scss']
})
export class PlacementsOtherinfoListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists = [];

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/placements-otherinfo/').subscribe(
        data => {
          this.lists = data.data;
          // console.log(this.list_sections);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

}
